export enum JobCampaignStatus {
    SCHEDULED = 'scheduled',
    ACTIVE = 'active',
    EXPIRED = 'expired',
}

export enum JobStatus {
    DRAFT = 'draft',
    OPEN = 'open',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
}

export type CandidateNumbersPerStageType = {
    entry: number,
    other: number,
    hire: number,
    rejection: number,
}

export interface User {
    id: number,
    name: string,
    avatar: string,
}

export interface Job {
    title: string,
    location: string | null,
    activeTo: string | null,
    activeFrom: string | null,
    numberOfUnreadMails: number | null,
    status: JobStatus | null,
    campaignStatus: JobCampaignStatus | null,
    pipeline: CandidateNumbersPerStageType | null,
    isStarred: boolean | null,
    isArchived: boolean | null,
    isHidden: boolean | null,
    subscribers: User[] | null,
}
